import { render, staticRenderFns } from "./ResetTel.vue?vue&type=template&id=3499f22d&scoped=true&"
import script from "./ResetTel.vue?vue&type=script&lang=js&"
export * from "./ResetTel.vue?vue&type=script&lang=js&"
import style0 from "./ResetTel.vue?vue&type=style&index=0&id=3499f22d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3499f22d",
  null
  
)

export default component.exports